export default __webpack_public_path__ + "static/media/logo_strapi.72d5bba6.png";